import { ShieldCheck, Lock } from "lucide-react";
import { Link } from "react-router-dom";

interface PrivacyPromiseProps {
  variant?: "banner" | "inline";
}

const PrivacyPromise = ({ variant = "banner" }: PrivacyPromiseProps) => {
  if (variant === "inline") {
    return (
      <div className="flex items-start gap-2 text-xs text-muted-foreground mt-3">
        <Lock className="w-3.5 h-3.5 shrink-0 mt-0.5 text-primary" />
        <p>
          We never sell your information. Only a licensed Mom&nbsp;&&nbsp;Pop agent will contact you. By submitting, you consent to be contacted by phone, text, or email.{" "}
          <Link to="/privacy" className="underline hover:text-foreground">Privacy Policy</Link>
        </p>
      </div>
    );
  }

  return (
    <section className="bg-surface-alt py-6 border-y border-border">
      <div className="container">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-center sm:text-left">
          <div className="flex items-center gap-2">
            <ShieldCheck className="w-5 h-5 text-primary" />
            <span className="text-sm font-semibold text-foreground">Your Privacy Is Sacred</span>
          </div>
          <p className="text-xs text-muted-foreground max-w-lg">
            We <span className="font-semibold text-foreground">never sell, share, or trade</span> your personal information. You will only ever be contacted by a licensed agent from Mom&nbsp;&&nbsp;Pop Insurance — no third parties, no spam, ever.
          </p>
          <Link to="/privacy" className="text-xs text-primary hover:text-primary/80 underline whitespace-nowrap">
            Read Our Privacy Policy →
          </Link>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPromise;
